import React, {PureComponent, ReactNode} from "react";
import {Text} from "@eo-locale/react";

type ListButtonProps = {
    text: string,
    color: string,
    textcolor: string
    onClick: () => void,
    icon?: string
};


export class ListButton extends PureComponent<ListButtonProps> {

    render(): ReactNode {
        const {
            text,
            color,
            textcolor,
            onClick,
            icon
        } = this.props


        return (
            <div className={"listbutton text-center text-base leading-6 font-medium md:px-2"}>
                 <button className={`bg-${color} rounded-md p-2 text-${textcolor} w-full`} onClick={onClick}>
                     {icon &&
                         <i className={`fa-kit fa-fw text-${textcolor} text-regular fa-${icon} align-middle  inline-block mr-2`}/>
                 } <Text id={text}/></button>
            </div>
        );
    }
}
